/**
 * Created by zzy on 2019/8/5.
 */
import SecuritySystem from './SecuritySystem.vue'
export default SecuritySystem



// WEBPACK FOOTER //
// ./src/views/monitoring/securitySystem/index.js